module.exports = __webpack_public_path__ + "img/Newbie_Dagger_03_Warrior.8060311c.png";